import React, {Component} from 'react'

import BottomButton from '../ui/BottomButton'

import Screen from '../ui/Screen'
import ErrorMessageDialog from '../ui/ErrorMessageDialog'

import ControlPanel from "./ImportScreen/ControlPanel"
import ShowList from "./ImportScreen/ShowsList"

import parse from 'csv-parse'

/**
 * <ImportScreen />
 */

class ImportScreen extends Component {

	state = {
		shows: [],
		dialog: undefined,
	}

	constructor(props) {
		super(props)
		this.handleLoadClick = this.handleLoadClick.bind(this)
		this.handleCheckShow = this.handleCheckShow.bind(this)
		this.handleLoadButtonClick = this.handleLoadButtonClick.bind(this)
	}

	handleLoadClick(csv) {
		parse(csv, {delimiter: ';'}, (err, output) => {
			if (err) {
				this.setState({
					dialog: <ErrorMessageDialog
						message = "Не удалось открыть csv файл"
						onClose = {() => {
							this.setState({
								dialog: undefined
							})
						}}
					/>
				})
			} else {
				let showNameColumnIndex = undefined
				let artistsNameColumnIndex = undefined
				let dataColumnIndex = undefined
				if (output[0]) {
					for (let index in output[0]) {
						switch (output[0][index]) {
							case "Название шоу":
								showNameColumnIndex = index
								break
							case "Ведущие":
								 artistsNameColumnIndex = index
								break
							case "Дата":
								dataColumnIndex = index
								break
							default:

						}
					}
				}
				let shows = output.splice(1).map((show, index) => {
					let s = {}
					if (showNameColumnIndex !== undefined) {
						s.name = show[showNameColumnIndex]
					}
					if (dataColumnIndex !== undefined) {
						s.date = show[dataColumnIndex]
					}
					if (artistsNameColumnIndex !== undefined) {
						s.artists = show[artistsNameColumnIndex]
					}
					return s
				})
				this.setState({
					shows: shows
				})
			}
		})
	}

	handleCheckShow(show) {
		show.checked = !show.checked
		this.forceUpdate()
	}

	readyToSave() {
		for (let show of this.state.shows) {
			if (show.checked) {
				return true
			}
		}
		return false
	}

	handleLoadButtonClick(shows) {
	}

	render() {

		return <Screen>

			<ControlPanel
				onLoadClick = {this.handleLoadClick}
			/>

			<ShowList
				shows = {this.state.shows}
				onCheckShow = {this.handleCheckShow}
			/>

			<BottomButton style = {{alignSelf: "flex-end"}}
				variant = "contained"
				color = "default"
				disabled = {!this.readyToSave()}
				onClick = {e => {
					e.stopPropagation()
					this.handleLoadButtonClick(this.state.shows.filter(show => show.checked))
				}}
			>Загрузить</BottomButton>

		</Screen>

	}

}

export default ImportScreen
